import { render, staticRenderFns } from "./Rule_Ntpp.vue?vue&type=template&id=52e8bdda&"
import script from "./Rule_Ntpp.vue?vue&type=script&lang=js&"
export * from "./Rule_Ntpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports